import { render, staticRenderFns } from "./ContactInformationModal.vue?vue&type=template&id=10d3113c"
import script from "./ContactInformationModal.vue?vue&type=script&lang=ts"
export * from "./ContactInformationModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactInformationModal.vue?vue&type=style&index=0&id=10d3113c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports